import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, FolderKanban, Loader2 } from "lucide-react";
import { PROJECT_STATUS, isBusy } from "./utils";

export const ProjectSidebar = ({ projects, activeId, onSelect, onNew }) => (
  <aside className="w-full lg:w-72 shrink-0 bg-white border border-slate-200 rounded-lg" data-testid="agency-project-list">
    <div className="flex items-center justify-between p-4 border-b border-slate-200">
      <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-500">Projects πελατών</div>
      <Button size="sm" onClick={onNew} data-testid="agency-new-project-btn">
        <Plus className="w-4 h-4 mr-1" /> Νέο
      </Button>
    </div>
    <div className="max-h-[60vh] overflow-y-auto divide-y divide-slate-100">
      {projects.length === 0 && <div className="p-4 text-sm text-slate-500">Δεν υπάρχουν projects ακόμα.</div>}
      {projects.map((p) => {
        const busy = isBusy(p.status);
        return (
          <button
            key={p.id}
            onClick={() => onSelect(p.id)}
            data-testid={`agency-project-item-${p.id}`}
            className={`w-full text-left px-4 py-3 transition-colors duration-150 hover:bg-slate-50 ${activeId === p.id ? "bg-blue-50 border-l-2 border-[#0052CC]" : ""}`}
          >
            <div className="flex items-center gap-2 font-medium text-slate-900">
              <FolderKanban className="w-4 h-4 text-[#0052CC]" />
              <span className="truncate">{p.client_name}</span>
              {busy && <Loader2 className="w-3.5 h-3.5 animate-spin text-slate-400" />}
            </div>
            <div className="mt-1 text-xs text-slate-500 flex gap-2">
              <span>{PROJECT_STATUS[p.status] || p.status}</span>
              <span>·</span>
              <span>{p.counts?.total || 0} leads</span>
              <span className="text-emerald-600">{p.counts?.approved || 0} ✓</span>
            </div>
          </button>
        );
      })}
    </div>
  </aside>
);
